"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useNotification = () => {
    const { notification: { addError, addSuccess } } = (0, react_1.useContext)(context_1.EnrichContext);
    return { addError, addSuccess };
};
exports.useNotification = useNotification;
exports.default = exports.useNotification;
